module.exports = __webpack_public_path__ + "img/northstar-4.abba3412.jpg";